import ChatStore from "@/components/Playground/chat-store";
import { deconstructMessageId } from "@/components/Playground/utils";
import { IndividualRunResponseI } from "@/queries/types";
import { displayErrorToast } from "@/utils/toast";

export const ERROR_TYPES = {
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  PROVIDER_ERROR: "PROVIDER_ERROR",
} as const;

export const ERRORS = {
  [ERROR_TYPES.INTERNAL_SERVER_ERROR]: "An error occurred while processing your request.",
  [ERROR_TYPES.PROVIDER_ERROR]: "Provider error",
};

export type ErrorType = (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];

interface HandleChatWebSocketErrorOptions {
  messageId: string;
  variableSetIndex: number;
  chatStore: ChatStore;
  errorType?: ErrorType;
  response?: IndividualRunResponseI;
}

export const handleChatWebSocketError = ({
  messageId,
  variableSetIndex,
  chatStore,
  errorType,
  response,
}: HandleChatWebSocketErrorOptions) => {
  const errorMessage = errorType ? ERRORS[errorType] : ERRORS[ERROR_TYPES.INTERNAL_SERVER_ERROR];

  displayErrorToast(errorMessage);

  //Check if message exists if not create it and if yes update it
  const message = chatStore.getMessageById(messageId);

  if (!message) {
    chatStore.addMessage(variableSetIndex, {
      id: messageId,
      role: deconstructMessageId(messageId).role,
      content: [],
      individual_run_request_id: deconstructMessageId(messageId).individual_run_request_id,
      created_at: new Date().toISOString(),
      error: {
        type: "error",
        message: errorMessage,
        verbose: response?.individual_run?.status_message,
      },
    });
  } else {
    chatStore.updateMessage(messageId, {
      error: {
        type: "error",
        message: errorMessage,
        verbose: response?.individual_run?.status_message,
      },
    });
  }

  chatStore.setPendingRequestId(variableSetIndex, null);
  chatStore.setStreamingMessageId(variableSetIndex, null);
};
